<template>
    <div class="main">
        <c-panel>
            <el-form label-position="top" class="u-mb-10">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_cod" filterable :clearable="!instituicaoTravada"
                                :disabled="instituicaoTravada" placeholder="Selecione a instituição"
                                :loading="loadingInstituicoes" @change="buscar" style="width: 100%;">
                                <el-option v-for="item in instituicoes" :key="item.codigo" :label="item.nome" :value="item.codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Servidor">
                            <el-input v-model="filtro.busca" clearable placeholder="Pesquisar por nome ou nº de registro"
                                @keyup.enter.native="buscar"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-button @click="buscar" type="info" plain icon="el-icon-search" style="width: 100%; margin-top: 21px;">FILTRAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="avisoAcesso" type="warning" :closable="false" class="u-mb-15" :title="avisoAcesso"></el-alert>

            <!-- Vínculo sem unidade no RH some do filtro. Sem este aviso, quem tem
                 duas escolas conclui que a tela ficou presa na primeira. -->
            <el-alert v-if="semUnidade.length" type="warning" :closable="false" class="u-mb-15"
                :title="semUnidade.length === 1
                    ? 'A instituição ' + semUnidade[0] + ' não aparece no filtro.'
                    : semUnidade.length + ' instituições suas não aparecem no filtro.'"
                :description="'Ela ainda não foi associada a uma unidade do sistema de RH, '
                    + 'e os servidores da folha vêm de lá. '
                    + (semUnidade.length > 1 ? 'São elas: ' + semUnidade.join(', ') + '. ' : '')
                    + 'A associação é feita em Folha de Ponto > Configurações > Instituições.'"></el-alert>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 110px;">Nr. Registro</th>
                            <th>Nome</th>
                            <th class="hidden-mobile">Unidade</th>
                            <th class="hidden-mobile">Cargo</th>
                            <th style="width: 90px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.registro">
                            <td>{{ item.nr_registro || item.registro }}</td>
                            <td>
                                <!-- Mesma ação do botão da coluna Ação: clicar no nome é o
                                     caminho natural e evita mirar o botão no fim da linha. -->
                                <a href="#" class="link-servidor" :title="'Lançamentos de ' + item.nome"
                                    @click.prevent="abrirLancamentos(item)">{{ item.nome }}</a>
                            </td>
                            <td class="hidden-mobile">{{ item.instituicao_nome || '-' }}</td>
                            <td class="hidden-mobile">{{ item.cargo || '-' }}</td>
                            <td class="u-text-center acao">
                                <el-button @click="abrirLancamentos(item)" title="Lançamentos" type="primary"
                                    icon="el-icon-search" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="5" class="u-text-center">
                                {{ pesquisou ? 'Nenhum servidor encontrado.' : 'Selecione uma instituição ou pesquise por um servidor.' }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList && paginate.qtdItens">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">{{ paginate.qtdItens }} servidor(es) encontrado(s).</div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > porPagina">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPagePagination" :page-size="porPagina" background
                                layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
// Prefixo das chaves de sessão do sistema.
const CHAVE_FILTRO = 'ed543672FolhaPontoServidores'

export default {
    data: () => ({
        statusList: true,
        pesquisou: false,
        loadingInstituicoes: false,
        porPagina: 50,
        instituicoes: [],
        restrito: false,
        avisoAcesso: '',
        semUnidade: [],
        items: [],
        filtro: { instituicao_cod: '', busca: '' },
        paginate: { page: 1, qtdItens: 0 }
    }),
    computed: {
        // Uma unidade só: não há o que escolher, e deixar o campo aberto sugere
        // que existem outras.
        instituicaoTravada () {
            return this.restrito && this.instituicoes.length <= 1
        }
    },
    mounted () {
        this.getConfig()
        this.getInstituicoes()
        this.restaurarFiltro()
    },
    methods: {
        /**
         * Esta tela é o ponto de partida do lançamento, e o usuário vai e volta
         * dela o dia inteiro. O filtro fica guardado na sessão para ele não ter
         * de reescolher a unidade a cada retorno — inclusive quando volta pelo
         * menu ou pelo botão do navegador, que não carregam a query da URL.
         */
        restaurarFiltro () {
            const query = this.$route.query

            if (query.instituicao_cod || query.busca) {
                this.filtro.instituicao_cod = query.instituicao_cod || ''
                this.filtro.busca = query.busca || ''
            } else {
                const salvo = this.filtroGuardado()

                if (salvo) {
                    this.filtro.instituicao_cod = salvo.instituicao_cod || ''
                    this.filtro.busca = salvo.busca || ''
                    this.paginate.page = Number(salvo.page) || 1
                }
            }

            if (this.filtro.instituicao_cod || this.filtro.busca) {
                this.load()
            }
        },
        filtroGuardado () {
            try {
                const salvo = JSON.parse(sessionStorage.getItem(CHAVE_FILTRO))
                const atual = this.$store.state.config.instituicao

                // Trocar a instituição no topo invalida o filtro anterior: senão
                // a tela abriria na escola antiga logo depois da troca.
                if (salvo && atual && Number(salvo.instituicao_topo) !== Number(atual.id)) {
                    return null
                }

                return salvo
            } catch (e) {
                return null
            }
        },
        guardarFiltro () {
            try {
                sessionStorage.setItem(CHAVE_FILTRO, JSON.stringify({
                    instituicao_cod: this.filtro.instituicao_cod,
                    instituicao_topo: (this.$store.state.config.instituicao || {}).id || null,
                    busca: this.filtro.busca,
                    page: this.paginate.page
                }))
            } catch (e) {
                // Sessão sem storage disponível: a tela funciona, só não lembra.
            }
        },
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        // Itens por página é parametrizável em Folha de Ponto > Configurações > Telas.
        getConfig () {
            this.$axios.get(`${this.baseUrl()}/configuracao/telas`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    if (res.data && res.data.itens_por_pagina) {
                        this.porPagina = Number(res.data.itens_por_pagina)
                    }
                })
                .catch(() => {})
        },
        /**
         * Unidade do RH correspondente à instituição selecionada no topo.
         *
         * O de/para vem no próprio payload (`instituicao_id`), porque os dois
         * cadastros usam códigos diferentes: no topo é o id da instituição do
         * sistema, aqui é o código do local de trabalho do RH.
         */
        unidadeDaInstituicaoAtual () {
            const atual = this.$store.state.config.instituicao

            if (!atual || !atual.id) return null

            const achada = this.instituicoes.find(i => Number(i.instituicao_id) === Number(atual.id))

            return achada ? achada.codigo : null
        },
        getInstituicoes () {
            this.loadingInstituicoes = true
            this.$axios.get(`${this.baseUrl()}/instituicoes`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    const d = res.data || {}

                    this.instituicoes = Array.isArray(d.instituicoes) ? d.instituicoes : []
                    this.restrito = !!d.restrito
                    this.avisoAcesso = d.mensagem || ''
                    this.semUnidade = Array.isArray(d.sem_unidade) ? d.sem_unidade : []

                    // Quem só tem uma unidade não escolhe nada: a tela já abre
                    // filtrada nela e o select fica travado.
                    if (this.restrito && this.instituicoes.length === 1) {
                        this.filtro.instituicao_cod = this.instituicoes[0].codigo
                    }

                    // Nada restaurado da sessão nem da URL: abre na instituição
                    // escolhida no topo. Continua trocável aqui — a folha não
                    // depende dela —, mas é a expectativa de quem acabou de
                    // escolher a escola para trabalhar.
                    if (!this.filtro.instituicao_cod) {
                        const doTopo = this.unidadeDaInstituicaoAtual()
                        if (doTopo) this.filtro.instituicao_cod = doTopo
                    }

                    this.loadingInstituicoes = false

                    if (this.filtro.instituicao_cod) this.load()
                })
                .catch(e => { this.loadingInstituicoes = false; this.$store.commit('throwException', e) })
        },
        buscar () {
            this.paginate.page = 1
            this.load()
        },
        load () {
            this.guardarFiltro()

            if (!this.filtro.instituicao_cod && !this.filtro.busca) {
                this.items = []
                this.paginate.qtdItens = 0
                this.pesquisou = false
                return
            }

            this.statusList = false
            this.pesquisou = true

            const params = {
                instituicao_cod: this.filtro.instituicao_cod,
                busca: this.filtro.busca,
                page: this.paginate.page,
                por_pagina: this.porPagina
            }

            this.$axios.get(`${this.baseUrl()}/servidores`, Object.assign({ params }, this.$store.getters.getHeaderAuth))
                .then(res => {
                    this.items = res.data.data || []
                    this.paginate.qtdItens = res.data.total || 0
                    this.statusList = true
                })
                .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        abrirLancamentos (servidor) {
            this.$router.push({
                path: `/admin/folha-ponto/servidor/${servidor.registro}`,
                query: { instituicao_cod: servidor.instituicao_cod || this.filtro.instituicao_cod }
            })
        },
        getPagePagination (page) {
            this.paginate.page = page
            this.load()
        }
    }
}
</script>

<style scoped>
.link-servidor {
    color: #000000;
    text-decoration: none;
    cursor: pointer;
}
.link-servidor:hover,
.link-servidor:focus {
    text-decoration: underline;
}
.dica-filtro {
    color: #909399;
    font-size: 11px;
    line-height: 1.4;
    margin-top: 2px;
}
</style>
